import { render, staticRenderFns } from "./StarRatingWithLabels.vue?vue&type=template&id=5200c9c4&scoped=true"
import script from "./StarRatingWithLabels.vue?vue&type=script&lang=js"
export * from "./StarRatingWithLabels.vue?vue&type=script&lang=js"
import style0 from "./StarRatingWithLabels.vue?vue&type=style&index=0&id=5200c9c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5200c9c4",
  null
  
)

export default component.exports